function About() {
  return (
    <section>
      <h1>About This App</h1>
      <p>
        The goal of this demo is to show basic client-side routing between a
        few static pages using React Router.
      </p>
    </section>
  );
}

export default About;

